import { post, get } from '../axios'

// 查询重复配置
export function buyitwith_list_post(map, option) {
  return post(
    `${process.env.VUE_APP_BUYITWITH}/buyitwith/list`,
    map,
    option
  ).then(response => response)
}

// 编辑
export function buyitwith_modify_post(map, option) {
  return post(
    `${process.env.VUE_APP_BUYITWITH}/buyitwith/modify`,
    map,
    option
  ).then(response => response)
}

// 分页查询
export function buyitwith_page_post(map, option) {
  return post(
    `${process.env.VUE_APP_BUYITWITH}/buyitwith/page`,
    map,
    option
  ).then(response => response)
}

// 查询单个条目
export function buyitwith_query_id_get(map, option) {
  return get(
    `${process.env.VUE_APP_BUYITWITH}/buyitwith/query/${map.id}`,
    map,
    option
  ).then(response => response)
}

// 保存
export function buyitwith_save_post(map, option) {
  return post(
    `${process.env.VUE_APP_BUYITWITH}/buyitwith/save`,
    map,
    option
  ).then(response => response)
}

// 删除
export function buyitwith_delete_id_get(map) {
  return get(
    `${process.env.VUE_APP_BUYITWITH}/buyitwith/delete/${map.id}`
  ).then(response => response)
}
